import React, { useEffect } from 'react';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { CommandPalette } from '../command/CommandPalette';
import { QuickAddTaskModal } from '../tasks/QuickAddTaskModal';
import { TaskDetailDrawer } from '../tasks/TaskDetailDrawer';
import { CreateWorkspaceModal } from '../workspace/CreateWorkspaceModal';
import { InviteMemberModal } from '../workspace/InviteMemberModal';
import { CreateProjectModal } from '../project/CreateProjectModal';
import { useWorkspace } from '../../context/WorkspaceContext';

export const AppShell = ({
  children,
  currentView,
  setCurrentView,
  currentProjectView,
  setCurrentProjectView
}) => {
  const {
    selectedTask,
    setSelectedTask,
    isQuickAddOpen,
    setIsQuickAddOpen,
    isCommandPaletteOpen,
    setIsCommandPaletteOpen,
    isCreateWorkspaceModalOpen,
    setIsCreateWorkspaceModalOpen,
    isInviteModalOpen,
    setIsInviteModalOpen,
    isCreateProjectModalOpen,
    setIsCreateProjectModalOpen
  } = useWorkspace();

  // Global Keyboard Shortcuts (Cmd/Ctrl + K and Q)
  useEffect(() => {
    const handleKeyDown = (e) => {
      const tag = e.target.tagName.toLowerCase();
      const isInput = tag === 'input' || tag === 'textarea' || e.target.isContentEditable;

      // Cmd+K or Ctrl+K
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setIsCommandPaletteOpen((prev) => !prev);
      }

      // 'Q' shortcut for Quick Add when not in input
      if (!isInput && !e.metaKey && !e.ctrlKey && !e.altKey && e.key.toLowerCase() === 'q') {
        e.preventDefault();
        setIsQuickAddOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [setIsCommandPaletteOpen, setIsQuickAddOpen]);

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: 'var(--bg-app)',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Global Top Bar */}
      <TopBar
        onOpenSidebarMobile={() => {}}
        currentView={currentView}
        setCurrentView={setCurrentView}
      />

      {/* Main Body Layout with Sidebar & Content */}
      <div style={{ display: 'flex', flex: 1 }}>
        <Sidebar
          currentView={currentView}
          setCurrentView={setCurrentView}
          currentProjectView={currentProjectView}
          setCurrentProjectView={setCurrentProjectView}
        />

        <main
          style={{
            flex: 1,
            padding: '28px 32px 80px',
            maxWidth: '1600px',
            margin: '0 auto',
            width: '100%',
            overflowX: 'hidden'
          }}
        >
          {children}
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav currentView={currentView} setCurrentView={setCurrentView} />

      {/* Global Modals & Drawers */}
      <CommandPalette
        isOpen={isCommandPaletteOpen}
        onClose={() => setIsCommandPaletteOpen(false)}
        setCurrentView={setCurrentView}
        setCurrentProjectView={setCurrentProjectView}
      />

      <QuickAddTaskModal
        isOpen={isQuickAddOpen}
        onClose={() => setIsQuickAddOpen(false)}
      />

      <TaskDetailDrawer
        task={selectedTask}
        onClose={() => setSelectedTask(null)}
      />

      <CreateWorkspaceModal
        isOpen={isCreateWorkspaceModalOpen}
        onClose={() => setIsCreateWorkspaceModalOpen(false)}
      />

      <InviteMemberModal
        isOpen={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
      />

      <CreateProjectModal
        isOpen={isCreateProjectModalOpen}
        onClose={() => setIsCreateProjectModalOpen(false)}
        onProjectCreated={() => {
          setCurrentView('project_view');
          if (setCurrentProjectView) setCurrentProjectView('board');
        }}
      />
    </div>
  );
};
